// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Po-z","slideIn":"Qo-z"};